import { loadModules } from 'esri-loader'
import router from "@/router";

const serviceURL = 'https://services.maps.arizona.edu/pdc/rest/services/'
					// 'https://services.maps.arizona.edu/pdc/rest/services/'
					// 'https://pdc-betagistest.catnet.arizona.edu:6080/arcgis/rest/services'
const state = {
	stateMap: null,
	buildingFeatures: null,
	currentFloor: '1',
	highlightLayer: null,
	buildinghighlightLayer: null,
	roominteractivityLayer: null,
	customlabelLayer: null,
	buildinglabelLayer: null,
	interiorMappingDMSL: null,
	floors: ['B1', 'B', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
	floorURL:  {
		"B1": serviceURL + "Interior/MapServer/14",
		"B": serviceURL + "Interior/MapServer/15",
		"1": serviceURL + "Interior/MapServer/16",
		"2": serviceURL + "Interior/MapServer/17",
		"3": serviceURL + "Interior/MapServer/18",
		"4": serviceURL + "Interior/MapServer/19",
		"5": serviceURL + "Interior/MapServer/20",
		"6": serviceURL + "Interior/MapServer/21",
		"7": serviceURL + "Interior/MapServer/22",
		"8": serviceURL + "Interior/MapServer/23",
		"9": serviceURL + "Interior/MapServer/24",
		"10": serviceURL + "Interior/MapServer/25",
		"11": serviceURL + "Interior/MapServer/26",
		"12": serviceURL + "Interior/MapServer/27",
	},							
	
	subtleTilesURL 			: serviceURL + 'SubtleCanvasTiles/MapServer',
	enterpriseTilesURL		: serviceURL + 'EnterpriseTiles/MapServer/',
	publicTilesURL			: serviceURL + 'publicTiles/MapServer/',
	lightInteriorOpen 		: serviceURL + 'Interior/MapServer/',
	buildingFootprintURL	: serviceURL + 'EnterpriseFeatures/MapServer/74',

	hoverLabelTitle: null,

};

const mutations = {
	setMap(state, payload) {
		state.stateMap = payload
	},
	setHoverLabelTitle(state, payload) {
		state.hoverLabelTitle = payload
	},
	setZoomLevel(state, payload) {
		state.stateMap.setZoom(payload)
	},

	// Suppress labels from DSML. 
    suppressDSMLLabels (state, suppressFlag) {
    	loadModules(["esri/layers/ArcGISDynamicMapServiceLayer", ])
		.then(([ArcGISDynamicMapServiceLayer,  ]) => {
    	 
        if (suppressFlag) {
        	var optionsArray = [];  
	        var drawingOptions = new esri.layers.LayerDrawingOptions();  
	        drawingOptions.showLabels = false; 
	        for (var i = 14; i <= 27; i++) { // apply to layers 16-27
	          optionsArray[i] = drawingOptions
	        } 
	        state.interiorMappingDMSL.setLayerDrawingOptions(optionsArray); 
		} else {
            // Restore labels from DSML.  
            var optionsArray = [];  
            state.interiorMappingDMSL.setLayerDrawingOptions(optionsArray); 
        }
    	})
    },


};

const actions = {

	setCurrentFloor({state, dispatch}, newFloor) {
		state.currentFloor = newFloor
		state.highlightLayer.clear()
		dispatch('updateLayerVisibility', newFloor)
	},

	loadMapLayers ({ state, commit }) {
			loadModules(["esri/map", "esri/layers/ArcGISTiledMapServiceLayer", "esri/layers/ArcGISDynamicMapServiceLayer", 
				"esri/layers/GraphicsLayer", "esri/InfoTemplate"])
			.then(([Map, ArcGISTiledMapServiceLayer, ArcGISDynamicMapServiceLayer, GraphicsLayer, InfoTemplate  ]) => {				
				let basemapURL = ""
							

				// Set basemap
				if (router.currentRoute.query.basemap == 'enterprise') 		{		basemapURL = state.enterpriseTilesURL	}
				else if (router.currentRoute.query.basemap == 'public') 	{		basemapURL = state.publicTilesURL       }
				else {																basemapURL = state.subtleTilesURL		}

				const basemap 	   		= new ArcGISTiledMapServiceLayer(basemapURL)																


				const highlightLayer = new GraphicsLayer()
					  highlightLayer.id = 'highlightlayer'					  
					  if (state.hoverLabelTitle) { 
					  	highlightLayer.infoTemplate = new InfoTemplate(state.hoverLabelTitle, "${label}") 
					  	
					  	// This disables the titlebar on the infowindow
					  	if (state.hoverLabelTitle=="none") { 
					  		highlightLayer.infoTemplate.setTitle(" ") 
					  	}
					}
					 

				const buildinghighlightLayer = new GraphicsLayer()
					  buildinghighlightLayer.id = 'buildinghighlightlayer'

				const buildinglabelLayer = new GraphicsLayer()
					  buildinglabelLayer.id = 'buildinglabellayer'

				const roominteractivityLayer = new GraphicsLayer()
					  roominteractivityLayer.id = 'roominteractivitylayer'

				const customlabelLayer = new GraphicsLayer()
					  customlabelLayer.id = 'customlabellayer'

				const interiorMappingDMSL = new ArcGISDynamicMapServiceLayer(state.lightInteriorOpen, {
					id: "interiorMapping",
					opacity: 1,
					visible: "false"
				});

				state.interiorMappingDMSL = interiorMappingDMSL

				state.stateMap.addLayer(basemap)
				state.stateMap.addLayer(buildinghighlightLayer)
				state.stateMap.addLayer(highlightLayer)
				if ( router.currentRoute.query.hideInterior != 'true' ) { state.stateMap.addLayer(state.interiorMappingDMSL) }
				state.stateMap.addLayer(buildinglabelLayer)
				state.stateMap.addLayer(roominteractivityLayer)
				state.stateMap.addLayer(customlabelLayer)

				state.highlightLayer = highlightLayer
				state.buildinghighlightLayer = buildinghighlightLayer
				state.buildinglabelLayer = buildinglabelLayer
				state.roominteractivityLayer = roominteractivityLayer
				state.customlabelLayer = customlabelLayer

				interiorMappingDMSL.on("update-end", function () {
		        	////console.log("Interior Loaded")
		        	commit('setMapReady', true)		        	
				})
				if (router.currentRoute.query.hideInterior=='true') { commit('setMapReady', true) }

				var lastState = null
		        highlightLayer.on("mouse-move", function(evt) {
		          // Hover only works is hoverLabelTitle exists
		          if (!state.hoverLabelTitle) { return }

		          // debounce
		          if(evt.graphic.attributes["label"] === lastState){
		            return;
		          }

		          // display popup
		          setTimeout(function(){
		            state.stateMap.infoWindow.setFeatures([evt.graphic]);
		            state.stateMap.infoWindow.show(evt.screenPoint, state.stateMap.getInfoWindowAnchor(evt.screenPoint));
		            // Get length of whatever is longer the title or the hover label.  Use that to resize the box
		            let longestLength = evt.graphic.attributes["label"].length > state.hoverLabelTitle.length ? evt.graphic.attributes["label"].length : state.hoverLabelTitle.length
		            
		            // Need some extra width for the windows X
		            let dataLength = state.hoverLabelTitle && state.hoverLabelTitle != 'none'  ? 80 + longestLength * 8 : 28 + longestLength * 8
		            state.stateMap.infoWindow.resize(dataLength)
		            lastState = evt.graphic.attributes["label"];
		          }, 500);
		        });

			})

	},

	addPoints ({ state, commit, rootState }, payload) {
		//console.log("add Points", payload)
		return new Promise((resolve, reject) => {
			loadModules(["esri/symbols/SimpleLineSymbol", "esri/symbols/SimpleMarkerSymbol", "esri/geometry/Point", "esri/graphic",
				"esri/symbols/TextSymbol", "esri/symbols/Font", "esri/Color",])
			.then(([SimpleLineSymbol, SimpleMarkerSymbol, Point, Graphic, TextSymbol, Font, Color]) => {

/*				payload = [
							  {				
							    "latLong": "-110.95344, 32.231877",
							    "markerColor": [255,0,0,0.5],
							    "outlineColor": [0,0,255],
							    "label": "Exhibit 1",
							    "markerSize": 180,
							    "labelColor": [0,255,0],
							    "haloSize": 2,
							    "haloColor": [0,0,255],
							    "fontSize": 36, 
							    "yOffset" : 100 
							  },
							  {
							    "latLong": "-110.9520, 32.231879",
							    "markerColor": [255,255,0,1],
							    "label": "Exhibit 2",
							    "labelColor": [0,0,255],
							    "haloSize": 1,
							    "haloColor": [255,0,0,0.25]
							  },
							  { "latLong" : "-110.9525, 32.231879", "label" : "Feature", "xOffset" : 40 },
							  { "latLong" : "-110.9530, 32.232100", "label" : "Feature" },
							  { "latLong" : "-110.9540, 32.231950", "label" : "Feature", "xOffset" : 40 }
							]*/
			
				let features = []
				payload.forEach((point) => {
					// Define markerSymbol
			        var markerSymbol = new SimpleMarkerSymbol();
					//markerSymbol.setPath("M16,4.938c-7.732,0-14,4.701-14,10.5c0,1.981,0.741,3.833,2.016,5.414L2,25.272l5.613-1.44c2.339,1.316,5.237,2.106,8.387,2.106c7.732,0,14-4.701,14-10.5S23.732,4.938,16,4.938zM16.868,21.375h-1.969v-1.889h1.969V21.375zM16.772,18.094h-1.777l-0.176-8.083h2.113L16.772,18.094z");
			        // Sets shape of symbol
			        markerSymbol.setPath("M16,3.5c-4.142,0-7.5,3.358-7.5,7.5c0,4.143,7.5,18.121,7.5,18.121S23.5,15.143,23.5,11C23.5,6.858,20.143,3.5,16,3.5z M16,14.584c-1.979,0-3.584-1.604-3.584-3.584S14.021,7.416,16,7.416S19.584,9.021,19.584,11S17.979,14.584,16,14.584z");
					markerSymbol.setStyle(SimpleMarkerSymbol.STYLE_PATH);
					
					// Set defaults
					point.markerSize 	= point.markerSize ? point.markerSize : 40 // Default Marker Size
					point.markerColor 	= point.markerColor ? point.markerColor : [255, 255, 255, 0.8] // Default Color 
					point.labelColor 	= point.labelColor ? point.labelColor : [0, 0, 0, 0.8] // Default Color
					point.outlineColor  = point.outlineColor ? point.outlineColor: [0,0,0]
					markerSymbol.setSize(point.markerSize)
					markerSymbol.setOutline(new SimpleLineSymbol({ "color":point.outlineColor }))
					//markerSymbol.setOffset(point.xOffset || 0, point.markerSize / 2 + (point.yOffset || 0))
					markerSymbol.setOffset(0, point.markerSize / 2)
					markerSymbol.setColor(point.markerColor)
			        
			        var pointGeometry = new Point(point.latLong.split(',')) //new Point(-110.95344, 32.231877)
			        console.log(pointGeometry)

			        // Add Point to Map
			        let graphic = new Graphic(pointGeometry, markerSymbol)
			        state.customlabelLayer.add(graphic)
			        features.push(graphic)

			        // Dummy Data
			        //let point = { fontSize: 18, label: "Point Label", labelColor: [50,200,50,1], haloSize: 2, haloColor: [200,0,0,1]}

			        // Add Label to Point
			        let fontSize = point.fontSize ? point.fontSize : 18	// default size is 8pt

	    			const customLabel = new TextSymbol().setColor(
										    new Color(point.labelColor)).setAlign(Font.ALIGN_START).setFont(
										    new Font(`${fontSize}pt`).setWeight(Font.WEIGHT_BOLD).setFamily('Roboto,sans-serif')) ; 

	    			// set the text, create and add the graphic
	    			let labelText = point.label
	    			customLabel.setText(labelText)
	    			customLabel.setOffset(0 + (point.xLabelOffset || 0), -20 + (point.yLabelOffset || 0))
	    			const labelGraphic = new Graphic(pointGeometry, customLabel); 

		   			// Halo for label text
					if (point.haloSize) { customLabel.setHaloColor(new Color(point.haloColor)); 
								  	 		 customLabel.setHaloSize(point.haloSize); }

	    			state.customlabelLayer.add(labelGraphic)

				})

				// Center over features
				// zoomLevel will disable centering over bldgs, not sure if that is useful
				if (!router.currentRoute.query.zoomLevel ) { 								
					state.stateMap.setExtent(esri.graphicsExtent(features).expand(1.75))
				}

				
			})
		})
	},

	multiHighlightBuilding ({ state, commit, dispatch, rootState }, payload) {
		//console.log("Highlight Building", payload.bldgAlpha)
		return new Promise((resolve, reject) => {
			loadModules(["esri/map", "esri/layers/GraphicsLayer", "esri/graphicsUtils", "esri/symbols/SimpleLineSymbol", 
					 "esri/symbols/SimpleFillSymbol", "esri/Color", "esri/graphic", "esri/tasks/query", "esri/geometry/Point",
					 "esri/tasks/QueryTask", "esri/symbols/TextSymbol", "esri/symbols/Font"])
			.then(([Map, GraphicsLayer, graphicsUtils, SimpleLineSymbol, SimpleFillSymbol, Color, Graphic, Query, Point, QueryTask, TextSymbol, Font ]) => {

				//Enable Elevator Control
				commit('setShowElevator', true)

				// Gather Building numbers for query
				const buildingNumbers = payload.map((building) => {	return "'" + building.bldg + "'"	})

				// Query Definition
				var queryTask = new QueryTask(state.buildingFootprintURL);
					var query = new Query();
									query.returnGeometry = true;
									query.outFields = ["*"];
									query.where = "Buildings.SpaceNumLetter in (" + buildingNumbers + ")";

				// Execute this on Query completion
				queryTask.on("complete", function(event) {
					var features = event.featureSet.features;
					if (features.length > 0) {
						features.forEach((graphic, index) => {
							
						// Highlight the Building

						// Customize Symbol
							// Find building.  This will be used to get color and label
							let building = payload.find((building) => { return building.bldg == graphic.attributes["Buildings.SpaceNumLetter"] })

							// Clear Color if not provided
							if (!building.color) {
								building.color= new Color([0,0,0,0]) // transparent
							}
							// Create custom symbol
							const symbol = new SimpleFillSymbol("solid",
								new SimpleLineSymbol(SimpleLineSymbol.STYLE_SOLID, new Color([0, 0, 0, 1]), 3),								
								new Color(building.color))

							// Set symbol and add graphic
							graphic.setSymbol(symbol);
							state.buildinghighlightLayer.add(graphic);							

						// Label the building

			    			// Get center of graphic.  This is where the label is attached.
			    			const gExt = graphic.geometry.getExtent()
			    			const gCenter = gExt.getCenter()

			    			let fontSize = building.fontSize ? building.fontSize : 18	// default size is 8pt

			    			const customLabel = new TextSymbol().setColor(
												    new Color(building.labelColor)).setAlign(Font.ALIGN_START).setFont(
												    new Font(`${fontSize}pt`).setWeight(Font.WEIGHT_BOLD).setFamily('Roboto,sans-serif')) ; 

			    			// set the text, create and add the graphic
			    			let labelText = building.label
			    			customLabel.setText(labelText)
			    			const labelGraphic = new Graphic(gCenter, customLabel); 

			    			// Add Halo
			    			// Halo for label text
							if (building.haloSize) { customLabel.setHaloColor(new Color(building.haloColor)); 
										  	 		 customLabel.setHaloSize(building.haloSize); }


			    			state.customlabelLayer.add(labelGraphic)

							// Center over features
							// zoomLevel will disable centering over bldgs, not sure if that is useful
							if (!router.currentRoute.query.zoomLevel ) { 								
								state.stateMap.setExtent(esri.graphicsExtent(features).expand(1.5))
							}
						
						})
					} 
					resolve()
				})

				// Execute Query
				queryTask.execute(query);
			})
		})
	},


	highlightBuilding ({ state, commit, rootState }, payload) {
		//console.log("Highlight Building", payload.bldgAlpha)
		return new Promise((resolve, reject) => {
			loadModules(["esri/map", "esri/layers/GraphicsLayer", "esri/graphicsUtils", "esri/symbols/SimpleLineSymbol", 
					 "esri/symbols/SimpleFillSymbol", "esri/Color", "esri/graphic", "esri/tasks/query", "esri/geometry/Point",
					 "esri/tasks/QueryTask",])
			.then(([Map, GraphicsLayer, graphicsUtils, SimpleLineSymbol, SimpleFillSymbol, Color, Graphic, Query, Point, QueryTask ]) => {
				
				// Highlight Symbol
				const symbol = new SimpleFillSymbol("solid",
					new SimpleLineSymbol(SimpleLineSymbol.STYLE_SOLID, new Color([0, 0, 0, 1]), 5),
					new Color([255, 0, 0, 0]));

				// Query Definition
				var queryTask = new QueryTask(state.buildingFootprintURL);
					var query = new Query();
									query.returnGeometry = true;
									query.outFields = ["*"];
									query.where = "Buildings.SpaceNumLetter = '" + payload.bldgAlpha + "'";

				// Execute this on Query completion
				queryTask.on("complete", function(event) {
					var features = event.featureSet.features;
					if (features.length > 0) {
						features.forEach((graphic) => {
							graphic.setSymbol(symbol);
							state.buildinghighlightLayer.add(graphic);

							var pt = graphic.geometry.getExtent().getCenter();
							state.buildingFeatures = features
							//if (payload.zoomTo) { state.stateMap.setExtent(esri.graphicsExtent(features).expand(1.25)); }
							if (!router.currentRoute.query.zoomLevel ) { 
								state.stateMap.setExtent(esri.graphicsExtent(features).expand(1.5))
							}
							//state.stateMap.setZoom(22)
							var pt = graphic.geometry.getExtent().getCenter();
							state.stateMap.centerAt(pt); 
							
						})
					} 
					resolve()
				})

				// Execute Query
				queryTask.execute(query);
			})
		})
	},

	speedHighlightRoom ({ dispatch, state, rootState }, roomKey) {
		return new Promise((resolve, reject) => { 
			dispatch('clearGraphics')
			Object.keys(state.floorURL).forEach((item) => {
				resolve(dispatch('highlightRoom', {'roomKey': roomKey, 'floor': item}))
			})			
		})
	},

	highlightRoom ({ dispatch, commit, state, rootState }, payload) {
		dispatch('clearGraphics', 'highlightlayer')
		//console.log("Highlight Room", payload.roomKey)
		return new Promise((resolve, reject) => {
			loadModules(["esri/map", "esri/layers/GraphicsLayer", "esri/graphicsUtils", "esri/symbols/SimpleLineSymbol", 
					 "esri/symbols/SimpleFillSymbol", "esri/Color", "esri/graphic", "esri/tasks/query", "esri/geometry/Point",
					 "esri/tasks/QueryTask",])
			.then(([Map, GraphicsLayer, graphicsUtils, SimpleLineSymbol, SimpleFillSymbol, Color, Graphic, Query, Point, QueryTask ]) => {
				

				const symbol = new SimpleFillSymbol("solid",
					new SimpleLineSymbol(SimpleLineSymbol.STYLE_SOLID, new Color([255, 0, 0, 1]), 5),
					new Color([255, 0, 0, 0]));

				//const highlightLayer = state.stateMap.getLayer('highlightlayer')

				var serviceURL = state.floorURL[payload.floor]

				var queryTask = new QueryTask(serviceURL);
			        var query = new Query();
			        query.returnGeometry = true;
			        query.outFields = ["*"];
			        query.where = "ROOMEXT.roomKey = '" + payload.roomKey + "'"; 

		        // If feature is found, switch to floor, create and add graphic to map.
		        queryTask.on("complete", function (event) {		        	
		            var features = event.featureSet.features;
		            if (features.length > 0) {		            	
		            	dispatch('updateLayerVisibility', payload.floor)
		                features.forEach((graphic) => {
		                    // Symbolize the fetched graphic, add it to the GraphicsLayer, and add that to the map.
		                    graphic.setSymbol(symbol);	
		                    //console.log("Adding Highlight Graphic")
		                    state.highlightLayer.add(graphic);
								var pt = graphic.geometry.getExtent().getCenter();
									state.stateMap.centerAt(pt); 
									//this.stateMap.setZoom(22)
									if (!router.currentRoute.query.zoomLevel ) { 
										state.stateMap.setExtent(esri.graphicsExtent(state.buildingFeatures).expand(1.5))
									}
		                })
		            
		            // Show Map.  Wish I could remember why I put this in here.
	            	setTimeout(function () { commit('setShowMap', true) }, 1000);
		                
		            } else { 
		            	////console.log("Highlight Room: No Features " + serviceURL + ":" + query.where); 
		            };		        	
		        	resolve()
		        });
				
		        queryTask.execute(query);

			})
		})
	},

	highlightRoomsByKey ({ dispatch, state, rootState }, payload) { // (roomKeys, color, floor 
		return new Promise((resolve, reject) => {
			loadModules(["esri/map", "esri/layers/GraphicsLayer", "esri/graphicsUtils", "esri/symbols/SimpleLineSymbol", 
					 "esri/symbols/SimpleFillSymbol", "esri/Color", "esri/graphic", "esri/tasks/query", "esri/geometry/Point",
					 "esri/tasks/QueryTask",])
			.then(([Map, GraphicsLayer, graphicsUtils, SimpleLineSymbol, SimpleFillSymbol, Color, Graphic, Query, Point, QueryTask ]) => {
			
				// Create new symbol based on 'color'
				var symbol = new SimpleFillSymbol("solid",
				//new SimpleLineSymbol(SimpleLineSymbol.STYLE_SOLID, Color.fromRgb(payload.color), 3), Color.fromRgb(payload.color));
				new SimpleLineSymbol(SimpleLineSymbol.STYLE_SOLID, new Color(payload.color), 2), new Color(payload.color));

				// Interior service URL
				const serviceURL = state.floorURL[payload.floor]			

				// Build where clause
				const where = payload.version == 2 ? "ROOMEXT.roomKeyNum in (" + payload.roomKeys + ")" : "ROOMEXT.roomKey in (" + payload.roomKeys + ")"		
				console.log("Where: ", where)	

			    var queryTask = new QueryTask(serviceURL);
							        var query = new Query();
							        query.returnGeometry = true;
							        query.outFields = ["*"];
							        query.where = where; 

			    queryTask.on("complete", function (event) {

			        // Evaluate features (rooms) fetched from esri query of Interior service
			        var features = event.featureSet.features;

			        //console.log("Feature Count: ", features.length)
			        if (features.length > 0) {   

			            features.forEach((graphic, index) => {
			                graphic.setSymbol(symbol);	
			                // If hoverLabel is an array of values, use the matching index to get the per room hoverlabel
			                // otherwise hoverLabel is being used as a group label, and it will be the same for each room in this group.
			                if (payload.hoverLabel && payload.hoverLabel.length > 1) {
			                	graphic.attributes["label"]=payload.hoverLabel[index]
			                } else {
			                	graphic.attributes["label"]=payload.hoverLabel[0]
			                }
		                    //console.log("Adding Highlight Graphic")
		                    state.highlightLayer.add(graphic);
			            })

			        } else { 
			        	//console.log("Highlight Room: No Features ")
			        	return "No Features found on Current Floor: "
			        }
			        	
			    });
			    queryTask.execute(query);
			})
		})
	},

	centerOverRooms({state, getters, commit, rootState}, payload) {
		loadModules(["esri/map", "esri/tasks/query", "esri/tasks/QueryTask", "esri/graphicsUtils",					])
		.then(([Map, Query, QueryTask, graphicsUtils ]) => {
			// Interior service URL
			const serviceURL = state.floorURL[payload.floor]	
			const where = payload.version == 2 ? "ROOMEXT.roomKeyNum in (" + payload.roomArray + ")" : "ROOMEXT.roomKey in (" + payload.roomArray + ")"	
			console.log("Centering Where: ", where)
	        var queryTask = new QueryTask(serviceURL);
						        var query = new Query();
						        query.returnGeometry = true;
						        query.outFields = ["*"];
						        query.where = where; 

	        queryTask.on("complete", function (event) { 
	        	state.stateMap.setExtent(esri.graphicsExtent(event.featureSet.features).expand(2))
	        	// Show Map
	            setTimeout(function () { commit('setShowMap', true) }, 0);
	        })	

	        queryTask.execute(query);
		})
	},


	updateLayerVisibility ({ state, rootState }, floor) {
		//console.log("updateLayerVisibility: ", floor)
		var visibleLayerIds = [];
			var layerInfos = state.interiorMappingDMSL.layerInfos;

			layerInfos.forEach((layerinfo) => {
				//console.log("Show Detail: ", rootState.ui.showDetail)
				if (rootState.ui.showDetail && layerinfo.name == "Plan_" + floor) {
					visibleLayerIds.push(layerinfo.id)
				}

				if (layerinfo.name == "Level_" + floor) {
					visibleLayerIds.push(layerinfo.id)
				}
			})

			state.interiorMappingDMSL.setVisibleLayers(visibleLayerIds);
	},

	labelBuildings({ state }, payload){
		//console.log("Label Buildings")
		loadModules(["esri/Color", "esri/graphic", "esri/symbols/TextSymbol", "esri/symbols/Font", "esri/tasks/query", "esri/tasks/QueryTask"				])
		.then(([Color, Graphic, TextSymbol, Font, Query, QueryTask ]) => {
			// Get Buildings from GIS

			var features = []
			var queryTask = new QueryTask(state.buildingFootprintURL)

			var query = new Query();
			query.returnGeometry = true;
			query.outFields = ["*"];
			query.where = "1=1";

			queryTask.on("complete", function(event) {
				features = event.featureSet.features;
				
				// Label Buildings

	    		let bldgLabelSize = "16"
	    		let zoomlevel = state.stateMap.getZoom()
	    		if (zoomlevel == 20) { bldgLabelSize = 20; }
	    		if (zoomlevel > 20) { bldgLabelSize = 24; }
	     		if (zoomlevel > 24) { bldgLabelSize = 40; }
	    		
	    		features.forEach((graphic) => {

	    			let buildingLabel = new TextSymbol().setColor(
											    new Color([128,0,0,.5])).setAlign(Font.ALIGN_START).setFont(
											    new Font(`${bldgLabelSize}pt`).setWeight(Font.WEIGHT_BOLD).setFamily('Roboto,sans-serif')) ;  

					// Use the shorter of cartoName or buildingName
					let cartoName = graphic.attributes['Buildings.CartoName']
					let name = graphic.attributes['Buildings.Name']
					let labelText = cartoName	

					// Exceptions
					let exceptionList = ['167A', '479', '476', '572', '475', '472', '155C', '155M', '155N', '155H', '409', '408', '408A']
					if (exceptionList.indexOf(graphic.attributes['Buildings.SpaceNumLetter']) > -1) { labelText = "" }				
					
					if (name && cartoName && name.length < cartoName.length) { labelText = name }

						// Original
							buildingLabel.setText(labelText)
							const gExt = graphic.geometry.getExtent()
					    	const gCenter = gExt.getCenter()
					    	const labelGraphic = new Graphic(gCenter, buildingLabel); 
					    	state.buildinghighlightLayer.add(labelGraphic)
					})


				})

			queryTask.execute(query);			
    	})
    },

	clearGraphics ({ state }, layerid) {
		////console.log("Clear Graphics", layerid)
		loadModules(["esri/map", "esri/layers/GraphicsLayer", "esri/graphicsUtils", ])
		.then(([Map, GraphicsLayer, graphicsUtils,  ]) => {
			
			state.stateMap.graphicsLayerIds.forEach((graphicsLayerId) => {
			  const gLayer = state.stateMap.getLayer(graphicsLayerId);

			  if (layerid) {
					if (gLayer.id == layerid) {
						////console.log("Match Found, Clearing:  " + gLayer.id);
						gLayer.clear();
					}
				} else { 
					gLayer.clear(); 
				}
			})
		})
	},

	addRoomInteractivity({ state }, bldgAlpha) {	
		return new Promise((resolve, reject) => {
			loadModules(["esri/map", "esri/layers/GraphicsLayer", "esri/symbols/SimpleFillSymbol", "esri/symbols/SimpleLineSymbol", "esri/Color", "esri/graphicsUtils", "esri/graphic", "esri/tasks/query", 
					 "esri/tasks/QueryTask",])
			.then(([Map, GraphicsLayer, SimpleFillSymbol, SimpleLineSymbol, Color, graphicsUtils, Graphic, Query, QueryTask ]) => {

				const transparentSymbol = new SimpleFillSymbol("solid",
					new SimpleLineSymbol(SimpleLineSymbol.STYLE_SOLID, new Color([0, 0, 0, 0]), 5),
					new Color([255, 0, 0, 0]));

				var features = []
				var queryTask = new QueryTask(state.floorURL[state.currentFloor])

				var query = new Query();
				query.returnGeometry = true;
				query.outFields = ["*"];

				query.where = "ROOMEXT.BldgAlpha = '" + bldgAlpha + "'";

				queryTask.on("complete", function(event) {
					features = event.featureSet.features;
					console.log("RI FeatureCount: ", features.length)
					if (features.length > 0) {	
						features.forEach(function(feature) {
							feature.setSymbol(transparentSymbol); 
							console.log("Add Room Interactive Graphic")

							// Prevents duplicate graphics from building up
							if (state.roominteractivityLayer.graphics.findIndex((graphic) => 
								graphic.attributes['ROOMEXT.roomKey'] == feature.attributes['ROOMEXT.roomKey']) == -1) {
								state.roominteractivityLayer.add(feature);
							} else {
								console.log("Duplicate Graphic not added")
							}							
						})

						//if (added) { console.log(roominteractivityLayer.graphics.length + " Interactive Graphics") }
						//if (vm.clVisible) { applyLabels() }
						resolve()

					} else { }
				})

				queryTask.execute(query);
			})
		})
	},

	applyLabels ({state, dispatch}, labelJson) {   
		return new Promise((resolve, reject) => {
			loadModules(["esri/map", "esri/layers/GraphicsLayer", "esri/symbols/SimpleFillSymbol", "esri/symbols/TextSymbol",
						 "esri/symbols/SimpleLineSymbol", "esri/Color", "esri/graphicsUtils", "esri/graphic", "esri/symbols/Font",])
			.then(([Map, GraphicsLayer, SimpleFillSymbol, TextSymbol, SimpleLineSymbol, Color, graphicsUtils, Graphic, Font]) => {
 		
	    		console.log("Graphics ready to label: ", state.roominteractivityLayer.graphics.length)
	    		console.log("labelJson: ", labelJson)
	    		labelJson.rooms.forEach((room, index) => {	
	    			//console.log("Room: ", room)
	    			// Find the graphic
	    			let graphic = state.roominteractivityLayer.graphics.find((graphic) => { 
	    				return graphic.attributes['ROOMEXT.RM_ID'] == room })

	    			const gExt = graphic.geometry.getExtent()
	    			const gCenter = gExt.getCenter()

	    			const customLabel = new TextSymbol().setColor(
										    new Color([160,0,0])).setAlign(Font.ALIGN_START).setFont(
										    new Font(`8pt`).setWeight(Font.WEIGHT_BOLD).setFamily('Roboto,sans-serif')) ; 

	    			//let labelText = graphic.attributes['ROOMEXT.RM_ID']
	    			let labelText = labelJson.labels[index]

	    			// set the text, create and add the graphic
	    			customLabel.setText(labelText)
	    			const labelGraphic = new Graphic(gCenter, customLabel); 
	    			state.customlabelLayer.add(labelGraphic) 
	    	 	})
	    	 	resolve() // This function isn't even asynchronous
	    	})
		})
    },




}

export default {
	state,
	actions,
	mutations
};